import styled from "styled-components";

export const Button = styled.button`
  display: inline-flex;
  padding: 11px 21px !important;
  background: none;
  border-style: solid !important;
  border-width: 3px !important;
  border-color: ${({ theme, color }) =>
    color ? color : theme.excitement} !important;
  color: ${(props) => props.theme.confusion} !important;
  font-family: Aeonik, sans-serif;
  font-size: 20px;
  line-height: 1.5;
  font-weight: bold;
  cursor: pointer;
  border-radius: 0;
  justify-content: center;
  transition: all 0.1s ease-in-out;
  &:hover,
  &:focus,
  &:active {
    background: ${({ theme, color }) => (color ? color : theme.excitement)};
    color: white !important;
  }

  @media (max-width: 960px) {
    padding: 8px 16px;
    font-size: 18px;
  }
`;
